<template>
  <div class="content" style="width:924px;">
      <el-table
        border
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">

        <!-- 姓名 -->
            <el-table-column
                prop="name"
                :label="$t('name')"
                width="120">
            </el-table-column>

            <!-- 头像 
            <el-table-column
                :label="$t('avatar')"
               >
                <template slot-scope="scope">
                    <img :src="scope.row.avatar" alt="" class="avatar">
                </template>
            </el-table-column>-->

            <el-table-column
                prop="user_mobile"
                width="150"
                :label="$t('email')">
            </el-table-column>

            <!-- 添加时间 -->
            <el-table-column
                prop="ctime"
                width="130"
                :label="$t('addTime')">
            </el-table-column>

            <!-- 订单数 -->
            <el-table-column
                prop="order_num"
                width="150"
                label="Amount of Order">
            </el-table-column>

            <!-- 用户数量 -->
            <el-table-column
                prop="user_num"
                :label="$t('userNum')">
            </el-table-column>
			
            <el-table-column
                prop="sales_money"
                :label="$t('salesAmount')">
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
                :label="$t('action')"
                
                width="100">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="userOrder(scope.row)">
                        <!-- 订单 -->
                        {{$t('orders')}}
                    </el-button>
                    <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">
                        <!-- 编辑 -->
                        {{$t('edit')}}
                    </el-button>
                    <el-button type="text" size="small" @click="delUser(scope.row, scope.$index)">
                        <!-- 删除 -->
                        {{$t('del')}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <Pagination
            v-if="tableData.length>0"
            :totalPage="totalPage"
            :limit="limit"
            @changePage="handleCurrentChange"
        ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
    components: {
        Pagination
    },
    data() {
        return {
            tableData: [],
            page: 1,
            limit: 10,
            totalPage: 0
        }
    },
    methods:{
        userOrder(val) {
            this.$router.push({
                name: 'stafforder',
                query: {id: val.id}
            })
        },
        handleCurrentChange() {
            this.page += 1
            this.list()
        },
        delUser(v, index) {
            const _this = this
            this.$alert( _this.$t('deleteUser') + v.name, {
                confirmButtonText: _this.$t('confirm'), // '确定',
                callback: action => {
                    
                    _this.$api.delstaff({id: v.id}).then( res => {
                        if(res.status) {
                            _this.$message({
                                message: _this.$t('successfullyDelete') // "删除成功"
                            })
                            _this.tableData.splice(index, 1)
                        } else {
                             _this.$message({
                                message: _this.$t('failed')// "删除失败"
                            })
                        }
                    })
                }
            });
            // alert(v.id)
        },
        handleClick(val, type) {
            if(type == 'edit') {
                this.$router.push({
                    name: 'staffadd',
                    query: {id: val.id}
                })
            }
//    12312311321321
        },
        list() {
            this.$api.getstafflists({
					id: window.localStorage.getItem('businessId'),
					page: this.page,
					limit: this.limit
				}).then(res =>{
                    if(res.status) {
                        this.tableData = res.data.data

                        this.totalPage = Math.ceil(res.data.count / this.limit) 
                    }
                })
        }
    },
    created() {
        console.log(123213)
        this.list()
    },
    
}
</script>

<style lang="scss" scoped>
.avatar{
    width: 24px;
    height: 24px;
}
</style>